require('babel-polyfill');
import Vue from 'vue';

import './assets/plugins/pace/pace-theme-flash.css';
import './assets/plugins/bootstrapv3/css/bootstrap.min.css';
import './assets/plugins/font-awesome/css/font-awesome.css';
import './assets/plugins/simple-line-icons/simple-line-icons.css';
import './assets/plugins/jquery-scrollbar/jquery.scrollbar.css';
import './assets/plugins/select2/css/select2.min.css';
import './assets/plugins/switchery/css/switchery.min.css';
import './assets/plugins/dropzone/css/dropzone.css';
import './assets/plugins/jquery-nestable/jquery.nestable.css';
import "./assets/plugins/rickshaw/rickshaw.min.css";
import "./assets/plugins/nvd3/nv.d3.min.css";    
import './assets/pages/css/pages-icons.css';
import './assets/pages/css/pages.css';
import './assets/pages/css/themes/simple.css';
import './pages/vue-multiselect/dist/vue-multiselect.min.css';
import './assets/plugins/bootstrap-datepicker/css/datepicker3.css';
import './assets/plugins/bootstrap-daterangepicker/daterangepicker-bs3.css';
import './assets/plugins/bootstrap-timepicker/bootstrap-timepicker.min.css';
import './assets/plugins/pace/pace.min.js';
import './assets/plugins/jquery/jquery-1.11.1.min.js';
import './assets/plugins/modernizr.custom.js';
import './assets/plugins/jquery-ui/jquery-ui.min.js';
import './assets/plugins/bootstrapv3/js/bootstrap.min.js';
import './assets/plugins/jquery/jquery-easy.js';
import './assets/plugins/jquery-unveil/jquery.unveil.min.js';
import './assets/plugins/jquery-bez/jquery.bez.min.js';
import './assets/plugins/jquery-ios-list/jquery.ioslist.min.js';
import './assets/plugins/jquery-actual/jquery.actual.min.js';
import './assets/plugins/jquery-scrollbar/jquery.scrollbar.min.js';
import './assets/plugins/classie/classie.js';
import './assets/plugins/select2/js/select2.full.min.js';
import './assets/plugins/switchery/js/switchery.js';
import './assets/plugins/jquery-validation/js/jquery.validate.js';
import './assets/plugins/jquery-nestable/jquery.nestable.js';
import './assets/plugins/bootstrap-datepicker/js/bootstrap-datepicker.js';
import './assets/plugins/bootstrap-daterangepicker/daterangepicker.js';
import './assets/plugins/bootstrap-timepicker/bootstrap-timepicker.min.js';
import './assets/plugins/nvd3/lib/d3.v3.js';
import "./assets/plugins/rickshaw/rickshaw.min.js";
import './assets/pages/js/pages.js';
import './assets/js/scripts.js';



// WEBPACK FOOTER //
// ./src/vendor.js